module.exports = __webpack_public_path__ + "img/users-03.6db1b2e3.svg";